export enum ELsKeys {
  PAYMENT_PRINTFUL_INTENT = 'payment-printful-intent',
  PAYMENT_PRINTFUL_PENDING = 'payment-printful-pending',
  PRINTFUL_DATA = 'printful-data',
  LANGUAGE_AND_PAGE_DATA = 'language-and-page-data',
  AUTH_REACHED_FROM = 'auth-reached-from'
}

export const ELsKeyAuthReachedFromOptions = {
  CREATE_NFT: 'create-nft'
};
